import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg2Styles = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "2 Styles" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "24x24px---NoNo-Def-No-Frame-&-Header-Color",
			transform: "translate(-618.000000, -68.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Portrait",
				transform: "translate(53.000000, 68.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "2-Styles",
					transform: "translate(565.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Frame-for-Icon",
						x: 0,
						y: 0,
						width: 24,
						height: 24
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Icon",
						transform: "translate(1.000000, 1.000000)",
						children: [/* @__PURE__ */ _jsxs("g", {
							id: 1,
							transform: "translate(13.000000, 0.000000)",
							children: [/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle",
								fill: "#AFBCC5",
								x: 0,
								y: 21,
								width: 6,
								height: 1,
								rx: .15
							}), /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle",
								fill: "#8C9BA8",
								x: 0,
								y: 0,
								width: 9,
								height: 19,
								rx: .15
							})]
						}), /* @__PURE__ */ _jsxs("g", {
							id: 1,
							children: [/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle",
								fill: "#AFBCC5",
								x: 0,
								y: 21,
								width: 6,
								height: 1,
								rx: .15
							}), /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle",
								fill: "#8C9BA8",
								x: 0,
								y: 0,
								width: 9,
								height: 19,
								rx: .15
							})]
						})]
					})]
				})
			})
		})
	})]
});
export { Svg2Styles as ReactComponent };
